export const DependentRelationship = Object.freeze({
    "Child": "C",
    "Spouse": "S",
    "DomesticPartner": "D",
    "DpChild": "R",
    "All":["C", "S", "D", "R"],
    "Children": ["C", "R"],
    "SignificantOther": ["S", "D"]
})